import {ProductImageTypes} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {useCookie, useCookieValueCallback} from '@aboutyou/storage';
import {ProductImageType} from '@aboutyou/ui-components';
import {PRODUCT_IMAGE_TYPE_COOKIE_KEY} from '@aboutyou/utils';
import {useMemo} from 'react';

const transformRawValue = (raw?: string): ProductImageType | undefined => {
  if (raw === 'model' || raw === 'product') {
    return raw;
  }
  return undefined;
};

export const getProtoProductImageType = (
  productImageType: ProductImageType | undefined,
): ProductImageTypes => {
  switch (productImageType) {
    case 'model':
      return ProductImageTypes.MODEL;
    case 'product':
      return ProductImageTypes.BUST;
    default:
      return ProductImageTypes.UNSPECIFIED;
  }
};

export const useProtoProductImageType = () => {
  const [productImageType] = useProductImageType();

  return useMemo(
    () => getProtoProductImageType(productImageType),
    [productImageType],
  );
};

export const useProductImageType = () => {
  const [productImageType, updateProductImageType] = useCookie<
    ProductImageType | undefined
  >({
    cookieName: PRODUCT_IMAGE_TYPE_COOKIE_KEY,
    defaultValue: undefined,
    transformRawValue,
  });

  return [productImageType, updateProductImageType] as const;
};

export const useProductImageTypeCallback = () => {
  const productImageTypeCallback = useCookieValueCallback<
    ProductImageType | undefined
  >({
    cookieName: PRODUCT_IMAGE_TYPE_COOKIE_KEY,
    defaultValue: undefined,
    transformRawValue,
  });

  return productImageTypeCallback;
};
